import React from "react";

function TopWidgets({
  totalProspects = 0,
  newProspectsThisMonth = 0,
  newProspectsPercent = "0%",
  expiredProspects = 0,
  expiredProspectsPercent = "0%",
  marketableProspects = 0,
  marketableProspectsPercent = "0%",
  onClickTotal,
  onClickNewThisMonth,
  onClickExpired,
  onClickMarketable,
}) {
  const widgets = [
    {
      title: "Total prospects",
      value: totalProspects,
      statClass: "font-bold",
      statContent: <i className="fa fa-users" />,
      onClick: onClickTotal,
      clickable: true,
    },
    {
      title: "New prospects this month",
      value: newProspectsThisMonth,
      statClass: "font-bold text-success",
      statContent: (
        <>
          {newProspectsPercent} <i className="fa fa-level-up" />
        </>
      ),
      onClick: onClickNewThisMonth,
      clickable: true,
    },
    {
      title: "Expired Prospects",
      value: expiredProspects,
      statClass: "font-bold text-danger",
      statContent: (
        <>
          {expiredProspectsPercent} <i className="fa fa-level-up" />
        </>
      ),
      onClick: onClickExpired,
      clickable: true,
    },
    {
      title: "Marketable Prospects",
      value: marketableProspects,
      statClass: "font-bold text-info",
      statContent: (
        <>
          {marketableProspectsPercent} <i className="fa fa-level-down" />
        </>
      ),
      onClick: onClickMarketable,
      clickable: true,
    },
  ];

  return (
    <div className="row">
      {widgets.map((widget, index) => (
        <div className="col-lg-3" key={index}>
          <div
            className={`card float-e-margins ${widget.clickable ? "cursor-pointer" : ""}`}
            onClick={widget.onClick || undefined}
            style={widget.clickable ? { cursor: "pointer" } : {}}
          >
            <div className="card-body">
              <h4 className="no-margins">{widget.value}</h4>
              <div className={`stat-percent ${widget.statClass}`}>
                {widget.statContent}
              </div>
              <small>{widget.title}</small>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TopWidgets;